// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_POST = "p\u0159id\u00e1n\u00ed diskuze";
export const ADD_FEED_POST = "P\u0159idej diskuzi";
export const COUNSELLING_IS_ARCHIVED = "Poradna je uzav\u0159ena";
export const FORUM_ADD_CONTEST = "P\u0159idej sout\u011b\u017e";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00ed ot\u00e1zku";
export const FORUM_POST_ADMINCLUB_MENU = "Adminclub";
export const FORUM_REPORTED_POSTS = "Nahl\u00e1\u0161en\u00e9 p\u0159\u00edsp\u011bvky";
export const FORUM_TOPIC_DELETE = "Vyma\u017e";
export const FORUM_TOPIC_EDIT = "Uprav popis a fotku";
export const FORUM_TOPIC_SEO_WITH_AI = "Skontroluj diskuze s AI";
export const SEO_DESCRIPTION_FORUM_topic = "V\u0161echno na t\u00e9ma %(topic)s, co maminky zaj\u00edm\u00e1. M\u00edsto pln\u00e9 zku\u0161enost\u00ed, rad, tip\u016f a trik\u016f p\u0159\u00edmo z prvn\u00ed ruky.";
export const SEO_TITLE_FORUM = "F\u00f3ra";
export const TO_action_YOU_HAVE_TO_BE_loggedIn = "Pro %(action)s mus\u00ed\u0161 %(loggedIn)s.";
export const TO_BE_LOGGED_IN = "b\u00fdt p\u0159ihl\u00e1\u0161en\u00e1";
